module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMy40NDIiIGhlaWdodD0iMTIuNzgzIiB2aWV3Qm94PSIwIDAgMTMuNDQyIDEyLjc4MyI+CiAgICA8ZGVmcz4KICAgICAgICA8c3R5bGU+CiAgICAgICAgICAgIC5jbHMtMXtmaWxsOiNlZmNlNGF9CiAgICAgICAgPC9zdHlsZT4KICAgIDwvZGVmcz4KICAgIDxwYXRoIGlkPSJzdGFyIiBkPSJNNi43MjEgMS4zMThMOC44IDUuNTI2bDQuNjQ0LjY3NS0zLjM2IDMuMjc1Ljc5MyA0LjYyNS00LjE1Ni0yLjE4M0wyLjU2NyAxNC4xbC43OTMtNC42MjNMMCA2LjJsNC42NDQtLjY3NXoiIGNsYXNzPSJjbHMtMSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtMS4zMTgpIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/star.svg
// module id = Av0H
// module chunks = 0